import { useEffect, useState } from 'react';
import {
  useFragment, graphql, fetchQuery, useRelayEnvironment,
} from 'react-relay';
import { nanoid } from 'nanoid';
import { useSearchZustandStore } from '@/helpers/searchctx.js';
import Emitter from '@/helpers/emitter.js';
import { lang } from '@/helpers/translate';
import { useZusUserConnectedStore } from '@/helpers/user-auth.js';

/*
MAP Listener var (filter, map) changing call search
and up map results to store
*/
const fragmentMapSearch = graphql`
  fragment mapSpacesWithParams on Query @argumentDefinitions (params: {type: "SearchSpaceParams"}, corpoRef: {type:"String"}) {
    results: searchSpaceByParams(params: $params) {
      spaces {
        id
        searchMap {
          location
          slug
          place_id
        }
        dataByCategory(category: "production") {
          price {
            amount_excl_tax
          }
          corpoPrice: price(input: {corpoRef : $corpoRef}) {
            amount_excl_tax
          }
        }
      }
      byCity {
        id
        location
        spacesCount
      }
      byDistrict {
        id
        location
        spacesCount
      }
    }
  }
`;

const queryMapSearch = graphql`
  query mapSpaceWithParamsQuery ($params: SearchSpaceParams, $corpoRef: String) {
    ...mapSpacesWithParams @arguments(params: $params, corpoRef: $corpoRef)
  }
`;

function MapResGraphql({ data, newFetch }) {
  // console.log('search/event/map results', !!data?.results);
  useEffect(() => {
    const pinResults = data?.results;
    if (newFetch && pinResults
      && (pinResults?.spaces || pinResults?.byCity || pinResults?.byDistrict)) {
      Emitter.emit('search_map_build_clearAllMarkers', true);
      if (pinResults?.spaces?.length
        || pinResults?.byCity?.length
        || pinResults?.byDistrict?.length) {
        useSearchZustandStore.setState({ mapDataResults: { results: pinResults } });
      } else {
        useSearchZustandStore.setState({ mapDataResults: { results: [] } });
      }
    }
  }, [newFetch]);

  return null;
}

function MapEvent() {
  const mapEvent = useSearchZustandStore((state) => state.mapEvent);

  useEffect(() => {
    if (['mapidlecall', 'mapidlecallclearmarkers', 'mapchangeZoom', 'mapdragend', 'mapchangeZoomAndClearMarker'].includes(mapEvent?.action)) {
      const { mapOutput } = useSearchZustandStore.getState();

      const dataout = {
        mapOutput: {
          ...mapOutput,
          ...mapEvent.data,
        },
      };

      if (!mapEvent.dontRun) {
        dataout.searchEvent = { action: `${mapEvent.action}callsearch` };
        useSearchZustandStore.setState({ clearAllMarkers: (mapEvent.action === 'mapchangeZoomAndClearMarker' || mapEvent.action === 'mapidlecallclearmarkers') ? nanoid() : false });
      }
      useSearchZustandStore.setState(dataout);
    }
  }, [mapEvent]);

  return null;
}

function RefetchMapSearch({ data: dataData, ...props }) {
  const data = useFragment(fragmentMapSearch, dataData);
  return <MapResGraphql {...{ data }} {...props} />;
}

export default function MapSearchContainer() {
  const [data, setData] = useState(null);
  const langCurrent = lang();
  const environment = useRelayEnvironment();

  const variables = useSearchZustandStore((state) => state.varGraphql);
  const userConnected = useZusUserConnectedStore((state) => state.userData);

  // console.log('search/event/map variables');

  useEffect(() => {
    if (Object.entries(variables).length) {
      fetchQuery(
        environment,
        queryMapSearch,
        {
          corpoRef: userConnected?.corpo?.ref,
          params: {
            ...variables,
            locationOnly: true,
            category: 'production',
            lang: langCurrent,
          },
        },
        { force: true, transactionId: nanoid() },
      ).subscribe({
        next: (dataRes) => {
          // console.log('search/event/map fetch query done');
          setData({ pins: { ...dataRes }, newFetch: nanoid() });
        },
        error: (error1) => {
          console.log('error1', error1);
        },
      });
    }
  }, [variables]);

  return (
    <>
      <RefetchMapSearch {...{ data: data?.pins || null, newFetch: data?.newFetch }} />
      <MapEvent />
    </>
  );
}
